export default __webpack_public_path__ + "static/EvolvingEnterpriseBgImg-09088427f770ec66b9b0d80a59090169.webp";